import { PageHeader } from "@/components/common/PageHeader";
import { useCurrency } from "@/lib/currency";
import { Gift, Coins, ShieldCheck, Sparkles } from "lucide-react";

function Row({ icon: Icon, title, desc }) {
  return (
    <div className="flex items-start gap-3 py-3 border-b border-border last:border-0">
      <span className="h-9 w-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center shrink-0"><Icon className="h-4.5 w-4.5" /></span>
      <div><p className="text-sm font-medium text-foreground">{title}</p><p className="text-xs text-muted-foreground">{desc}</p></div>
    </div>
  );
}

export default function LoyaltySettingsPage() {
  const { code, symbol } = useCurrency();
  return (
    <div data-testid="loyalty-settings-page">
      <PageHeader title="Loyalty Settings" subtitle="ReasonLoyaltyIQ — pack configuration & defaults" />
      <div className="max-w-2xl bg-card border border-border rounded-2xl shadow-sm p-6">
        <Row icon={Gift} title="Pack" desc="Loyalty & Rewards Intelligence (LOYALTY_INTELLIGENCE_PACK) — enabled for this tenant." />
        <Row icon={Coins} title="Reward Currency" desc={`Cashback & monetary rewards display in ${code} (${symbol}). Configure under Organization Settings → Regional.`} />
        <Row icon={ShieldCheck} title="Tenant Isolation" desc="All loyalty data is scoped to your tenant with full audit logging and RBAC." />
        <Row icon={Sparkles} title="Coming soon" desc="Membership & tiers, referral, coupons, AI Loyalty Agent, Digital Twin, analytics & mobile (next phases)." />
      </div>
    </div>
  );
}
